import { cell, resource, resourceFactory } from 'ember-resources';

export type ReactiveStringArray = {
  values: string[];
  addValue: (value: string) => void;
  removeValueAt: (index: number) => void;
  handleInputChangeAt: (index: number, event: Event) => void;
  setValueAt: (index: number, value: string) => void;
  updateValues: (values: string[]) => void;
};

function StringArrayResource(
  source: string[],
  updateSource: (values: string[]) => void
) {
  return resource<ReactiveStringArray>(() => {
    const values = cell<string[]>([...source]);

    const updateValues = (newValues: string[]) => {
      try {
        console.log('Setting values', newValues);
        updateSource([...newValues]);
        values.set([...newValues]);
      } finally {
        console.log('updated values', newValues);
      }
    };

    const addValue = (value: string) => {
      const newValues = [...values.current, value];
      updateValues(newValues);
    };

    const removeValueAt = (index: number) => {
      const newValues = [...values.current];
      newValues.splice(index, 1);
      updateValues(newValues);
    };

    const handleInputChangeAt = (index: number, event: Event) => {
      const value = (event.target as HTMLInputElement).value;
      const newValues = [...values.current];
      newValues[index] = value;
      updateValues(newValues);
    };

    const setValueAt = (index: number, value: string) => {
      try {
        console.log('Setting value at', index, value);
        const newValues = [...values.current];
        newValues[index] = value;
        updateValues(newValues);
      } finally {
        console.log('setValueAt', index, value);
      }
    };

    return () => ({
      values: values.current,
      addValue,
      removeValueAt,
      handleInputChangeAt,
      setValueAt,
      updateValues,
    });
  });
}

resourceFactory(StringArrayResource);

export { StringArrayResource };
